// ─── Temperature Chart ────────────────────────────────────────────────────────
export function TempChart({ readings, safeMin = 35, safeMax = 38, warnMax = 41, equipment }) {
  // If the equipment has explicit thresholds saved, honor them and
  // synthesize a tighter "ideal" band as max - 3°.
  if (equipment) {
    if (Number.isFinite(Number(equipment.temp_high_f))) warnMax = Number(equipment.temp_high_f);
    if (Number.isFinite(Number(equipment.temp_low_f)))  safeMin = Number(equipment.temp_low_f);
    safeMax = Math.min(warnMax - 1, safeMin + 3);
  }
  if (!readings || readings.length < 2) return (
    <div className="flex items-center justify-center h-20 text-gray-400 text-xs">Not enough data for chart</div>
  );
  const W = 400, H = 110;
  const pad = { top: 10, right: 10, bottom: 20, left: 28 };
  const iW = W - pad.left - pad.right;
  const iH = H - pad.top - pad.bottom;
  const temps = readings.map(r => r.temperature);
  const minT = Math.min(safeMin - 3, ...temps);
  const maxT = Math.max(warnMax + 3, ...temps);
  const tRange = maxT - minT;
  const xScale = i => pad.left + (i / (readings.length - 1)) * iW;
  const yScale = t => pad.top + (1 - (t - minT) / tRange) * iH;
  const pathD = readings.map((r, i) => `${i === 0 ? 'M' : 'L'} ${xScale(i).toFixed(1)} ${yScale(r.temperature).toFixed(1)}`).join(' ');
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{height:'110px'}}>
      <rect x={pad.left} y={yScale(safeMax)} width={iW} height={Math.max(0, yScale(safeMin) - yScale(safeMax))} fill="#dcfce7" opacity="0.7"/>
      <rect x={pad.left} y={yScale(warnMax)} width={iW} height={Math.max(0, yScale(safeMax) - yScale(warnMax))} fill="#fef9c3" opacity="0.7"/>
      <rect x={pad.left} y={pad.top} width={iW} height={Math.max(0, yScale(warnMax) - pad.top)} fill="#fee2e2" opacity="0.5"/>
      {[safeMin, safeMax, warnMax].map((t, i) => (
        <g key={t}>
          <line x1={pad.left} y1={yScale(t)} x2={W - pad.right} y2={yScale(t)}
            stroke={i === 2 ? '#ef4444' : i === 1 ? '#f59e0b' : '#22c55e'} strokeWidth="0.5" strokeDasharray="3,3" opacity="0.8"/>
          <text x={pad.left - 3} y={yScale(t) + 3} textAnchor="end" fontSize="7" fill="#6b7280">{t}°</text>
        </g>
      ))}
      <path d={pathD} fill="none" stroke="#6366f1" strokeWidth="1.5" strokeLinejoin="round"/>
      {readings.map((r, i) => (
        <circle key={i} cx={xScale(i)} cy={yScale(r.temperature)} r="2.5"
          fill={r.temperature > warnMax ? '#ef4444' : r.temperature > safeMax ? '#f59e0b' : '#22c55e'}/>
      ))}
    </svg>
  );
}
